import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import ShopForm from '../../../main/shops/shopForm';
import { getinitialValuesFromShop } from '../../../common/helpers/shops';

const EditShop = ({ shop, adminShopUser, updateShop, addNotification, shopLdFlags }) => {
  const saveAndRedirect = (data) =>
    updateShop(shop.id, data, shop).then(() => {
      addNotification({
        title: 'Success',
        level: 'success',
        message: 'Changes saved successfully',
      });
    });

  if (isEmpty(shop)) {
    return null;
  }

  return (
    <div>
      <ShopForm
        shopLdFlags={shopLdFlags}
        saveUpdatedShop={saveAndRedirect}
        initialValues={getinitialValuesFromShop(shop)}
        cancelHref="/admin/shops"
        shopUser={adminShopUser}
      />
    </div>
  );
};

EditShop.propTypes = {
  updateShop: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  shop: PropTypes.object,
  adminShopUser: PropTypes.object,
  shopLdFlags: PropTypes.object,
};

EditShop.defaultProps = {
  shop: {},
  adminShopUser: {},
  shopLdFlags: {},
};

export default EditShop;
